import { AUTH_MODE, CART_MODE, PAYMENT_MODE } from '@src/components/Checkout/constants';
import { PAYMENT_STEP_DIRECT_LINK_TYPES, type DirectLink } from '@src/domains/direct-links';
import { CheckoutMode } from '../types';

export const getInitialCheckoutMode = (params: {
  skipResumeCart?: boolean;
  skipResumeCartPage?: string;
  directLink?: DirectLink | null;
}): CheckoutMode => {
  const { skipResumeCart = false, skipResumeCartPage, directLink } = params;

  // Payment, sale and order links have no cart to resume and nothing to confirm.
  if (PAYMENT_STEP_DIRECT_LINK_TYPES.includes(directLink?.type ?? '')) {
    return PAYMENT_MODE;
  }

  return (skipResumeCartPage && skipResumeCartPage === 'true') || skipResumeCart ? AUTH_MODE : CART_MODE;
};
